export const supportMassage = {
  opEventSupport: '&subject=Op Event Support&content=Please help me with the process of a new risk case',
  helpMe: '=Please help me with this case: ',
  opEventSupportMessage: '&topicName=Op Event Support&message=Please help me with the process of a new risk case',
  linkAttendees: 'msteams:/l/meeting/new?attendees=',
  linkUser: 'msteams:/l/chat/0/0?users=',
};
